module.exports = __webpack_public_path__ + "static/media/no-files.5095ab18.png";